import { Col, Row, Table, Dropdown, Modal } from 'antd'


const ImageView = ({ 
      open,
      onCancel,
      showImg,
       }) => {
   
      
  return (
    <Modal
    title=""
    className='[&_.ant-modal-close]:-top-3 [&_.ant-modal-close]:-right-3 [&_.ant-modal-close]:!bg-white [&_.ant-modal-close]:w-9 [&_.ant-modal-close]:h-9 [&_.ant-modal-close]:rounded-full [&_.ant-modal-close]:text-black'
       open={open}
       okButtonProps={{ style: { background: 'grey' } }}
       onCancel={onCancel}
       footer={null}
  >
  < img src={showImg} alt='' />
  </Modal>
  );
};

export default ImageView;
